<template>
  <div class="feedback-container">
    <div class="container">
      <!-- 说明文字 -->
      <p class="description">
        如果在输入序列号查找机型遇到问题，可以在此发送给我们，以便我们改进我们的服务
      </p>

      <!-- 表单区域 -->
      <div class="form-section">
        <van-field
          v-model="snValue"
          label="机身后条码"
          placeholder="请输入机身后条码"
          required
          class="form-field"
        />
        
        <van-field
          v-model="modelValue"
          label="产品型号"
          placeholder="请输入产品型号"
          required
          class="form-field"
        />
        
        <van-field
          v-model="buyDate"
          label="购买日期"
          type="date"
          required
          class="form-field"
        />
      </div>

      <!-- 提交按钮 -->
      <van-button 
        type="primary" 
        size="large" 
        class="submit-btn"
        @click="submitFeedback"
      >
        问题反馈
      </van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog, Toast } from 'vant'

export default {
  name: 'SNFeedback',
  data() {
    return {
      snValue: '',
      modelValue: '',
      buyDate: '',
      token: ''
    }
  },
  created() {
    this.token = localStorage['access_token']
    if (!this.token) {
      this.checkToken()
    }
    // 获取URL参数中的序列号
    const urlParams = new URLSearchParams(window.location.search)
    this.snValue = urlParams.get('sn') || ''
  },
  mounted() {
    document.title = '序列号问题反馈'
  },
  methods: {
    // 检查token
    checkToken() {
      const token = localStorage['access_token']
      if (!token) {
        this.$router.push('/login')
      }
      return token
    },
    
    // 提交反馈
    submitFeedback() {
      if (!this.validateForm()) {
        Dialog.alert({
          title: '输入提示',
          message: '请输入机身后条码、型号和购买日期！'
        })
        return
      }

      this.submitFeedbackRequest()
    },
    
    // 验证表单
    validateForm() {
      return this.snValue.trim() !== '' && 
             this.modelValue.trim() !== '' && 
             this.buyDate.trim() !== ''
    },
    
    // 提交反馈请求
    submitFeedbackRequest() {
      let that = this
      let postUrl = this.global.BASE_RUL_ABC + '/v1/svc/newlosssnreport'
      
      let requestData = {
        "sn": this.snValue,
        "model": this.modelValue,
        "buydate": this.buyDate
      }
      
      console.log('提交数据:', requestData)
      
      Vue.axios.post(postUrl, requestData, {
        headers: {
          "Authorization": this.token,
          "Content-Type": "application/json"
        }
      })
      .then(function (result) {
        console.log('反馈结果:', result.data)
        if (result.data.code === "0") {
          Toast.success('反馈丢失SN成功！')
          // 延迟跳转，让用户看到成功提示
          setTimeout(() => {
            window.location.href = "index.html?access_token=" + that.token
          }, 1500)
        } else {
          Toast.fail(result.data.msg || '提交失败，请重试')
        }
      })
      .catch(function (error) {
        console.log(error)
        Toast.fail('访问网络有问题，请稍后重试！')
      })
    }
  }
}
</script>

<style scoped>
.feedback-container {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 80px;
  width: 100%;
  box-sizing: border-box;
}

.container {
  padding: 16px;
  max-width: 100%;
  box-sizing: border-box;
}

.description {
  text-align: left;
  font-size: 14px;
  color: #646566;
  line-height: 1.5;
  margin-bottom: 20px;
  word-break: break-all;
}

.form-section {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid #f0f0f0;
  overflow: hidden;
  margin-bottom: 20px;
}

.form-field {
  padding: 16px;
  margin: 0;
  border-bottom: 1px solid #f5f5f5;
}

.form-field:last-child {
  border-bottom: none;
}

/* 自定义 van-field 样式 */
:deep(.van-field__label) {
  color: #323233;
  font-weight: 500;
  text-align: left;
  width: 100px;
}

:deep(.van-field__control) {
  color: #323233;
  text-align: left;
}

:deep(.van-field__control::placeholder) {
  color: #c8c9cc;
}

.submit-btn {
  position: fixed;
  bottom: 20px;
  left: 5%;
  right: 5%;
  width: 90%;
  border-radius: 20px;
  background-color: #323233;
  border-color: #323233;
}

/* 响应式设计 */
@media (max-width: 360px) {
  .container {
    padding: 12px;
  }
  
  .form-field {
    padding: 14px;
  }
  
  :deep(.van-field__label) {
    width: 90px;
  }
}

@media (max-width: 320px) {
  .container {
    padding: 8px;
  }
  
  .form-field {
    padding: 12px;
  }
  
  :deep(.van-field__label) {
    width: 85px;
    font-size: 14px;
  }
}

/* 悬停效果（桌面端） */
@media (hover: hover) {
  .form-section:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
}
</style>